<template>
    <!-- <div class="row" style="height: calc(100% - 276px);">
      <div class=" col-xs-12 col-md-9 text-center q-pa-lg" style="margin: auto;">
        <h5>Processing message from I-Akaun</h5>    
        </div>
    </div>  -->
    <q-page style="">
        <div class="row justify-center" style="margin: auto; height: calc(100vh - 128px);">
            <div class="col-12 col-md-9 q-pa-lg" style="height: 100%;">
                <q-card  style="border-radius: 1rem !important; box-shadow: none !important; height: 100%; background: #fff; position: relative;"> 
                    <q-card-section style=" margin: 0;position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%); width: 100%;">
                    <div class="row justify-center q-pa-md" style="margin-top: auto; margin-bottom: auto;">
                        <!-- <div class="col-xs-12 col-sm-5 col-md-6 col-lg-5 q-py-md q-px-sm text-center">
                            <img  src="@/assets/maintenance.png" style="height: auto; width: 100%; max-height: 450px !important;" >
                        </div> -->
                        <div class="col-12 q-py-md q-px-sm" style="padding-left:20px">
                            <div class="text-bold q-mb-xs text-center" style="font-size: 24px !important;">Processing data from I-Akaun</div>
                            
                            <div class="q-mb-md text-center" style="font-size: 16px !important;">Please wait for a while..
                             </div>
                             <div class="text-center">
                               <q-spinner
                                color="blue-11"
                                size="3em"
                              />
                             </div>
                                <!-- <div>
                                Saturday, 20 June 2020 (9.00am-11.00pm)<br>
                                Sunday, 21 June 2020 (10.00am-11.00pm)<br>
                                
                            </div> -->
                            <!-- <div >We thank you for your patience and understanding.</div> -->
                            <!-- <br>
                            <q-btn unelevated style="background: #ff6666; color: white; border-radius: 0.5rem;"  label="Contact Us" @click="reroute()" ></q-btn> -->
                        </div>
                    </div>
                    </q-card-section>
                </q-card>
            </div>
        </div>
  </q-page>
</template>
<script>

import { mapActions } from 'vuex';
import sampleJson from '../assets/json/sampleBuy.json'
import store from '../store';
import {
  Loading,
  QSpinnerHourglass,
} from 'quasar'
export default {
  name: 'Transact',
  components:{

  },data(){
    return{}
  }
  ,  mounted(){
      Loading.show({
        spinner: QSpinnerHourglass,
          message: "Processing message from I-Akaun",
          messageColor: "white",
          spinnerSize: 90, // in pixels
          spinnerColor: "blue",
          customClass : 'bg-white'
        });

       /* var fileToRead = sampleJson.transactionType
        alert(fileToRead)
*/
        Loading.hide();
        this.trigger();
  },
  methods:{
    ...mapActions([
           "RerouteLogic"
    ]),

    trigger:function(){
        
    var fileToRead = sampleJson;
    this.RerouteLogic({
      JsonFile : fileToRead
    })
    }

  }
}
</script>